import cf from './cf';
import i1zv2_20211024 from './i1zv2_20211024';

export default class i1zv2b extends i1zv2_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: 'エントリーの確認、キャンセル・新規エントリー',
      class: 'i1zv2c',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
